import styled from 'styled-components';

const SelectContainer = styled.div`
  position: relative;
  width: 9.55rem;
  & input {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export default SelectContainer;
